exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_note__4cGKf{font-family:Roboto;font-size:.75rem;text-align:left;font-weight:300;margin-bottom:.5rem;color:#666}.style_note__4cGKf a{color:#2f93e0}", ""]);

// exports
exports.locals = {
	"note": "style_note__4cGKf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/form/Note/style.less
// module id = 1281
// module chunks = 8